(() => {
  const root = document.querySelector('[data-pc-shop-finder]');
  if (!root) return;

  const grid = root.querySelector('[data-product-grid]');
  const cards = Array.from(root.querySelectorAll('[data-product-card]'));
  const resultsCount = root.querySelector('[data-results-count]');
  const emptyState = root.querySelector('[data-empty-state]');
  const pagination = root.querySelector('[data-pagination]');
  const sortSelect = root.querySelector('[data-sort-select]');
  const categorySelect = root.querySelector('[data-mobile-category-select]');
  const chipsWrap = root.querySelector('[data-active-chips]');
  const desktopCompareWrap = root.querySelector('[data-sidebar-compare]');
  const desktopCompareBtn = root.querySelector('[data-desktop-compare]');
  const desktopCompareLabel = root.querySelector('[data-desktop-compare-label]');
  const desktopCompareMeta = root.querySelector('[data-desktop-compare-meta]');
  const desktopCompareClose = root.querySelector('[data-desktop-compare-close]');
  const compareModal = root.querySelector('[data-compare-modal]');
  const compareTableWrap = root.querySelector('[data-compare-table]');
  const mobileDrawer = root.querySelector('[data-mobile-drawer]');
  const desktopFilterMount = root.querySelector('[data-filter-content]');
  const mobileFilterMount = root.querySelector('[data-mobile-filter-content]');

  if (!grid || !cards.length) return;

  const pageSize = 10;
  let currentPage = 1;
  let activeCategory = 'all';
  let selectedCompareIds = [];

  const specsById = {};
  let maxPrice = 0;
  let maxBtu = 0;

  const categoryLabelMap = {
    all: 'All Categories',
    water: 'Water Chillers',
    glycol: 'Glycol Chillers',
    'cold-therapy': 'Cold Therapy',
    commercial: 'Commercial Chillers',
    clearance: 'Clearance',
    accessories: 'Accessories'
  };

  const categoryAliases = {
    water: 'water',
    'water-chillers': 'water',
    'standard-water-chillers': 'water',
    glycol: 'glycol',
    'glycol-chillers': 'glycol',
    'xl-glycol-chillers': 'glycol',
    'cold-therapy': 'cold-therapy',
    'cold-therapy-chillers': 'cold-therapy',
    'cold-plunge': 'cold-therapy',
    'cold-plunge-chillers': 'cold-therapy',
    commercial: 'commercial',
    'commercial-chillers': 'commercial',
    'commercial-water-chillers': 'commercial',
    'commercial-glycol-chillers': 'commercial',
    clearance: 'clearance',
    accessories: 'accessories'
  };

  const knownCategories = Object.keys(categoryLabelMap);

  const money = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    maximumFractionDigits: 0
  });

  const escapeHtml = (str) => String(str || '').replace(/[&<>"']/g, (char) => ({
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#039;'
  }[char]));

  function getInitialCategory() {
    const params = new URLSearchParams(window.location.search);
    const queryCategory = params.get('pc_cat');

    if (queryCategory && categoryAliases[queryCategory]) return categoryAliases[queryCategory];
    if (queryCategory && knownCategories.includes(queryCategory)) return queryCategory;

    const pathParts = window.location.pathname.split('/').filter(Boolean);
    const lastPart = pathParts[pathParts.length - 1];

    if (lastPart && categoryAliases[lastPart]) return categoryAliases[lastPart];
    if (lastPart && knownCategories.includes(lastPart)) return lastPart;

    return 'all';
  }

  cards.forEach((card) => {
    maxPrice = Math.max(maxPrice, Number(card.dataset.price || 0));
    maxBtu = Math.max(maxBtu, Number(card.dataset.btu || 0));

    const json = card.querySelector('[data-product-spec-json]');
    if (json) {
      try {
        specsById[card.dataset.id] = JSON.parse(json.textContent);
      } catch (err) {
        console.warn('Penguin Chillers compare JSON error:', err);
      }
    }
  });

  maxPrice = Math.ceil(maxPrice || 10000);
  maxBtu = Math.ceil(maxBtu || 60000);

  const state = {
    priceMin: 0,
    priceMax: maxPrice,
    btuMin: 0,
    btuMax: maxBtu,
    outdoor: 'all',
    leadTimes: new Set()
  };

  activeCategory = getInitialCategory();

  const uniqueValues = (attr) => {
    const map = new Map();

    cards.forEach((card) => {
      const raw = card.dataset[attr];
      if (!raw) return;
      map.set(raw, raw);
    });

    return Array.from(map.values()).sort((a, b) =>
      a.localeCompare(b, undefined, { numeric: true })
    );
  };

  const leadTimes = uniqueValues('leadTime');

  function rangePercent(value, max) {
    if (!max) return 0;
    return Math.min(100, Math.max(0, (Number(value) / Number(max)) * 100));
  }

  function getRangeStyle(min, max, absoluteMax) {
    return `--range-left: ${rangePercent(min, absoluteMax)}%; --range-right: ${rangePercent(max, absoluteMax)}%;`;
  }

  function filterMarkup() {
    const leadMarkup = leadTimes.map((item) => `
      <label class="pc-check">
        <input type="checkbox" data-filter-lead value="${escapeHtml(item)}">
        <span>${escapeHtml(item)}</span>
      </label>
    `).join('');

    return `
      <div class="pc-filter-group">
        <span class="pc-filter-label">Price</span>

        <div class="pc-range-value">
          <span data-price-min-value>${money.format(state.priceMin)}</span>
          —
          <span data-price-max-value>${money.format(state.priceMax)}</span>
        </div>

        <div
          class="pc-dual-range"
          data-dual-range="price"
          data-range-min="0"
          data-range-max="${maxPrice}"
          data-range-step="50"
          style="${getRangeStyle(state.priceMin, state.priceMax, maxPrice)}"
        >
          <div class="pc-dual-range__track">
            <div class="pc-dual-range__fill"></div>
          </div>

          <button
            class="pc-dual-range__handle pc-dual-range__handle--min"
            type="button"
            data-range-handle="min"
            aria-label="Minimum price"
          ></button>

          <button
            class="pc-dual-range__handle pc-dual-range__handle--max"
            type="button"
            data-range-handle="max"
            aria-label="Maximum price"
          ></button>
        </div>
      </div>

      <div class="pc-filter-group">
        <span class="pc-filter-label">BTU</span>

        <div class="pc-range-value">
          <span data-btu-min-value>${Number(state.btuMin).toLocaleString()} BTU</span>
          —
          <span data-btu-max-value>${Number(state.btuMax).toLocaleString()} BTU</span>
        </div>

        <div
          class="pc-dual-range"
          data-dual-range="btu"
          data-range-min="0"
          data-range-max="${maxBtu}"
          data-range-step="500"
          style="${getRangeStyle(state.btuMin, state.btuMax, maxBtu)}"
        >
          <div class="pc-dual-range__track">
            <div class="pc-dual-range__fill"></div>
          </div>

          <button
            class="pc-dual-range__handle pc-dual-range__handle--min"
            type="button"
            data-range-handle="min"
            aria-label="Minimum BTU"
          ></button>

          <button
            class="pc-dual-range__handle pc-dual-range__handle--max"
            type="button"
            data-range-handle="max"
            aria-label="Maximum BTU"
          ></button>
        </div>
      </div>

      <div class="pc-filter-group">
        <span class="pc-filter-label">Use Environment</span>

        <label class="pc-environment-switch">
          <input
            type="checkbox"
            data-filter-outdoor-switch
            ${state.outdoor === 'yes' ? 'checked' : ''}
          >

          <div class="pc-environment-switch__track">
            <div class="pc-environment-switch__icon">☀️</div>
            <div class="pc-environment-switch__thumb"></div>
            <div class="pc-environment-switch__icon">🌧️</div>
          </div>

          <div class="pc-environment-switch__copy">
            <strong data-env-switch-title>
              ${state.outdoor === 'yes' ? 'Outdoor Rated' : 'All Environments'}
            </strong>

            <span data-env-switch-helper>
              ${state.outdoor === 'yes' ? 'Showing outdoor-rated products only' : 'Showing all products'}
            </span>
          </div>
        </label>
      </div>

      <div class="pc-filter-group">
        <span class="pc-filter-label">Lead Time</span>

        <div class="pc-check-list">
          ${leadMarkup || '<div class="pc-range-value">No lead time values found.</div>'}
        </div>
      </div>
    `;
  }

  if (desktopFilterMount) desktopFilterMount.innerHTML = filterMarkup();
  if (mobileFilterMount) mobileFilterMount.innerHTML = filterMarkup();

  function updateEnvironmentSwitchText() {
    root.querySelectorAll('[data-env-switch-title]').forEach((el) => {
      el.textContent = state.outdoor === 'yes'
        ? 'Outdoor Rated'
        : 'All Environments';
    });

    root.querySelectorAll('[data-env-switch-helper]').forEach((el) => {
      el.textContent = state.outdoor === 'yes'
        ? 'Showing outdoor-rated products only'
        : 'Showing all products';
    });
  }

  function updateCategoryButtons() {
    root.querySelectorAll('[data-category]').forEach((btn) => {
      btn.classList.toggle('is-active', btn.dataset.category === activeCategory);
    });

    if (categorySelect) {
      categorySelect.value = activeCategory;
    }
  }

  function updateUrlCategory() {
    const url = new URL(window.location.href);

    if (activeCategory === 'all') {
      url.searchParams.delete('pc_cat');
    } else {
      url.searchParams.set('pc_cat', activeCategory);
    }

    window.history.replaceState({}, '', url.toString());
  }

  function updateRangeVisual(type) {
    const min = type === 'price' ? state.priceMin : state.btuMin;
    const max = type === 'price' ? state.priceMax : state.btuMax;
    const absoluteMax = type === 'price' ? maxPrice : maxBtu;

    root.querySelectorAll(`[data-dual-range="${type}"]`).forEach((range) => {
      range.style.setProperty('--range-left', `${rangePercent(min, absoluteMax)}%`);
      range.style.setProperty('--range-right', `${rangePercent(max, absoluteMax)}%`);
    });
  }

  function syncFilterInputs() {
    root.querySelectorAll('[data-price-min-value]').forEach((el) => {
      el.textContent = money.format(state.priceMin);
    });

    root.querySelectorAll('[data-price-max-value]').forEach((el) => {
      el.textContent = money.format(state.priceMax);
    });

    root.querySelectorAll('[data-btu-min-value]').forEach((el) => {
      el.textContent = `${Number(state.btuMin).toLocaleString()} BTU`;
    });

    root.querySelectorAll('[data-btu-max-value]').forEach((el) => {
      el.textContent = `${Number(state.btuMax).toLocaleString()} BTU`;
    });

    updateRangeVisual('price');
    updateRangeVisual('btu');

    root.querySelectorAll('[data-filter-outdoor-switch]').forEach((input) => {
      input.checked = state.outdoor === 'yes';
    });

    updateEnvironmentSwitchText();

    root.querySelectorAll('[data-filter-lead]').forEach((input) => {
      input.checked = state.leadTimes.has(input.value);
    });
  }

  function getRangeValueFromPointer(event, slider) {
    const rect = slider.getBoundingClientRect();
    const min = Number(slider.dataset.rangeMin || 0);
    const max = Number(slider.dataset.rangeMax || 100);
    const step = Number(slider.dataset.rangeStep || 1);
    const pointerX = event.clientX ?? event.touches?.[0]?.clientX ?? 0;
    const percent = Math.min(1, Math.max(0, (pointerX - rect.left) / rect.width));
    const rawValue = min + percent * (max - min);
    return Math.round(rawValue / step) * step;
  }

  function updateCustomRange(slider, handleType, event) {
    const type = slider.dataset.dualRange;
    const value = getRangeValueFromPointer(event, slider);

    if (type === 'price') {
      if (handleType === 'min') {
        state.priceMin = Math.min(value, state.priceMax);
      } else {
        state.priceMax = Math.max(value, state.priceMin);
      }

      updateRangeVisual('price');

      root.querySelectorAll('[data-price-min-value]').forEach((el) => {
        el.textContent = money.format(state.priceMin);
      });

      root.querySelectorAll('[data-price-max-value]').forEach((el) => {
        el.textContent = money.format(state.priceMax);
      });
    }

    if (type === 'btu') {
      if (handleType === 'min') {
        state.btuMin = Math.min(value, state.btuMax);
      } else {
        state.btuMax = Math.max(value, state.btuMin);
      }

      updateRangeVisual('btu');

      root.querySelectorAll('[data-btu-min-value]').forEach((el) => {
        el.textContent = `${Number(state.btuMin).toLocaleString()} BTU`;
      });

      root.querySelectorAll('[data-btu-max-value]').forEach((el) => {
        el.textContent = `${Number(state.btuMax).toLocaleString()} BTU`;
      });
    }
  }

  function commitRangeChange() {
    currentPage = 1;
    applyFilters();
  }

  function cardMatches(card) {
    const categories = card.dataset.categories || '';
    const price = Number(card.dataset.price || 0);
    const btu = Number(card.dataset.btu || 0);
    const outdoor = card.dataset.outdoor || 'no';
    const leadTime = card.dataset.leadTime || '';

    if (activeCategory !== 'all' && !categories.split('|').includes(activeCategory)) return false;
    if (price < state.priceMin || price > state.priceMax) return false;
    if (btu < state.btuMin || btu > state.btuMax) return false;
    if (state.outdoor !== 'all' && outdoor !== state.outdoor) return false;
    if (state.leadTimes.size && !state.leadTimes.has(leadTime)) return false;

    return true;
  }

  function sortCards(list) {
    const sort = sortSelect ? sortSelect.value : 'featured';

    return list.sort((a, b) => {
      if (sort === 'price-asc') return Number(a.dataset.price) - Number(b.dataset.price);
      if (sort === 'price-desc') return Number(b.dataset.price) - Number(a.dataset.price);
      if (sort === 'btu-asc') return Number(a.dataset.btu) - Number(b.dataset.btu);
      if (sort === 'btu-desc') return Number(b.dataset.btu) - Number(a.dataset.btu);
      if (sort === 'lead-asc') return Number(a.dataset.leadSort || 99) - Number(b.dataset.leadSort || 99);

      return cards.indexOf(a) - cards.indexOf(b);
    });
  }

  function renderChips() {
    if (!chipsWrap) return;

    const chips = [];

    if (activeCategory !== 'all') {
      chips.push({
        label: categoryLabelMap[activeCategory] || activeCategory,
        clear: () => {
          activeCategory = 'all';
          updateCategoryButtons();
          updateUrlCategory();
        }
      });
    }

    if (state.priceMin > 0 || state.priceMax < maxPrice) {
      chips.push({
        label: `${money.format(state.priceMin)} – ${money.format(state.priceMax)}`,
        clear: () => {
          state.priceMin = 0;
          state.priceMax = maxPrice;
        }
      });
    }

    if (state.btuMin > 0 || state.btuMax < maxBtu) {
      chips.push({
        label: `${Number(state.btuMin).toLocaleString()} – ${Number(state.btuMax).toLocaleString()} BTU`,
        clear: () => {
          state.btuMin = 0;
          state.btuMax = maxBtu;
        }
      });
    }

    if (state.outdoor !== 'all') {
      chips.push({
        label: 'Outdoor Rated',
        clear: () => {
          state.outdoor = 'all';
        }
      });
    }

    state.leadTimes.forEach((value) => {
      chips.push({
        label: value,
        clear: () => state.leadTimes.delete(value)
      });
    });

    chipsWrap.innerHTML = chips.map((chip, index) => `
      <span class="pc-chip">
        ${escapeHtml(chip.label)}
        <button type="button" data-chip-clear="${index}" aria-label="Clear ${escapeHtml(chip.label)}">×</button>
      </span>
    `).join('');

    chips.forEach((chip, index) => {
      const btn = chipsWrap.querySelector(`[data-chip-clear="${index}"]`);
      if (!btn) return;

      btn.addEventListener('click', () => {
        chip.clear();
        currentPage = 1;
        applyFilters();
      });
    });
  }

  function renderPagination(totalItems) {
    if (!pagination) return;

    const totalPages = Math.max(1, Math.ceil(totalItems / pageSize));
    currentPage = Math.min(currentPage, totalPages);

    if (totalItems <= pageSize) {
      pagination.innerHTML = '';
      pagination.hidden = true;
      return;
    }

    pagination.hidden = false;

    const pageButtons = [];

    for (let page = 1; page <= totalPages; page += 1) {
      const isEdge = page === 1 || page === totalPages;
      const isNear = Math.abs(page - currentPage) <= 1;

      if (isEdge || isNear) {
        pageButtons.push(`<button class="pc-page-btn${page === currentPage ? ' is-active' : ''}" type="button" data-page="${page}" aria-label="Go to page ${page}">${page}</button>`);
      } else if (pageButtons[pageButtons.length - 1] !== '<span class="pc-page-ellipsis">…</span>') {
        pageButtons.push('<span class="pc-page-ellipsis">…</span>');
      }
    }

    pagination.innerHTML = `
      <button class="pc-page-btn pc-page-btn--nav" type="button" data-page-prev ${currentPage === 1 ? 'disabled' : ''}>Previous</button>
      ${pageButtons.join('')}
      <button class="pc-page-btn pc-page-btn--nav" type="button" data-page-next ${currentPage === totalPages ? 'disabled' : ''}>Next</button>
    `;
  }

  function applyFilters() {
    updateCategoryButtons();
    syncFilterInputs();
    renderChips();

    cards.forEach((card) => card.classList.add('is-filtering'));

    window.setTimeout(() => {
      const matched = sortCards(cards.filter(cardMatches));
      const start = (currentPage - 1) * pageSize;
      const end = start + pageSize;

      cards.forEach((card) => {
        card.classList.add('is-hidden');
        grid.appendChild(card);
      });

      matched.forEach((card, index) => {
        grid.appendChild(card);

        if (index >= start && index < end) {
          card.classList.remove('is-hidden');
        }
      });

      cards.forEach((card) => card.classList.remove('is-filtering'));

      const showingStart = matched.length ? start + 1 : 0;
      const showingEnd = Math.min(matched.length, end);

      if (resultsCount) {
        resultsCount.textContent = matched.length
          ? `Showing ${showingStart}–${showingEnd} of ${matched.length} products`
          : 'Showing 0 products';
      }

      if (emptyState) {
        emptyState.classList.toggle('is-visible', matched.length === 0);
      }

      renderPagination(matched.length);
      updateCompareUI();
    }, 90);
  }

  function clearFilters() {
    activeCategory = 'all';
    state.priceMin = 0;
    state.priceMax = maxPrice;
    state.btuMin = 0;
    state.btuMax = maxBtu;
    state.outdoor = 'all';
    state.leadTimes.clear();
    currentPage = 1;

    updateCategoryButtons();
    updateUrlCategory();
    applyFilters();
  }

  function clearCompareSelection() {
    selectedCompareIds = [];
    updateCompareUI();
  }

  function updateCompareUI() {
    root.querySelectorAll('[data-product-card]').forEach((card) => {
      const selected = selectedCompareIds.includes(card.dataset.id);
      card.classList.toggle('is-compare-selected', selected);

      const checkbox = card.querySelector('[data-compare-check]');
      if (checkbox) checkbox.checked = selected;
    });

    const count = selectedCompareIds.length;
    const metaText = `${count} of 3 selected`;

    if (desktopCompareMeta) desktopCompareMeta.textContent = metaText;

    let label = 'Compare';

    if (count === 1) label = 'Select 1 More';
    if (count >= 2) label = `Compare ${count}`;

    if (desktopCompareLabel) desktopCompareLabel.textContent = label;

    if (desktopCompareWrap) {
      desktopCompareWrap.hidden = count === 0;
      desktopCompareWrap.classList.toggle('is-visible', count > 0);
    }
  }

  function toggleCompare(card, desiredState) {
    if (!card) return;

    const id = card.dataset.id;
    const currentlySelected = selectedCompareIds.includes(id);
    const shouldSelect = typeof desiredState === 'boolean' ? desiredState : !currentlySelected;

    if (!shouldSelect) {
      selectedCompareIds = selectedCompareIds.filter((item) => item !== id);
      updateCompareUI();
      return;
    }

    if (currentlySelected) return;

    if (selectedCompareIds.length >= 3) {
      const checkbox = card.querySelector('[data-compare-check]');
      if (checkbox) checkbox.checked = false;
      alert('You can compare up to 3 products at a time.');
      return;
    }

    selectedCompareIds.push(id);
    updateCompareUI();
  }

  function openCompareModal() {
    if (!compareModal || !compareTableWrap) return;

    const items = selectedCompareIds.map((id) => specsById[id]).filter(Boolean);
    if (items.length < 2) return;

    const sections = ['Chiller Specs', 'Product Specs', 'Power Specs'];
    let html = '';

    sections.forEach((sectionName) => {
      const rowNames = new Set();

      items.forEach((item) => {
        const section = item.sections?.[sectionName] || {};

        Object.entries(section).forEach(([key, value]) => {
          if (String(value || '').trim() !== '') rowNames.add(key);
        });
      });

      if (!rowNames.size) return;

      html += `<h3 class="pc-compare-section-title">${escapeHtml(sectionName)}</h3>`;
      html += '<table class="pc-compare-table"><thead><tr><th>Spec</th>';

      items.forEach((item) => {
        html += `<th><a href="${escapeHtml(item.url)}">${escapeHtml(item.title)}</a></th>`;
      });

      html += '</tr></thead><tbody>';

      rowNames.forEach((row) => {
        html += `<tr><th>${escapeHtml(row)}</th>`;

        items.forEach((item) => {
          const value = item.sections?.[sectionName]?.[row] || '—';
          html += `<td>${escapeHtml(value)}</td>`;
        });

        html += '</tr>';
      });

      html += '</tbody></table>';
    });

    compareTableWrap.innerHTML = html;
    compareModal.classList.add('is-visible');
    compareModal.setAttribute('aria-hidden', 'false');
  }

  function handleCompareClick() {
    if (selectedCompareIds.length >= 2) {
      openCompareModal();
      return;
    }

    alert('Select at least 2 products to compare. You can compare up to 3.');
  }

  root.addEventListener('pointerdown', (event) => {
    const handle = event.target.closest('[data-range-handle]');
    if (!handle) return;

    const slider = handle.closest('[data-dual-range]');
    if (!slider) return;

    event.preventDefault();

    const handleType = handle.dataset.rangeHandle;
    slider.setPointerCapture?.(event.pointerId);
    updateCustomRange(slider, handleType, event);

    const move = (moveEvent) => {
      updateCustomRange(slider, handleType, moveEvent);
    };

    const up = () => {
      window.removeEventListener('pointermove', move);
      window.removeEventListener('pointerup', up);
      commitRangeChange();
    };

    window.addEventListener('pointermove', move);
    window.addEventListener('pointerup', up);
  });

  root.addEventListener('click', (event) => {
    const categoryBtn = event.target.closest('[data-category]');
    if (categoryBtn) {
      activeCategory = categoryBtn.dataset.category || 'all';
      currentPage = 1;
      updateUrlCategory();
      applyFilters();
      return;
    }

    const clearBtn = event.target.closest('[data-clear-filters]');
    if (clearBtn) {
      clearFilters();
      return;
    }

    const openMobileFilters = event.target.closest('[data-open-mobile-filters]');
    if (openMobileFilters && mobileDrawer) {
      mobileDrawer.classList.add('is-visible');
      mobileDrawer.setAttribute('aria-hidden', 'false');
      return;
    }

    const closeMobileFilters = event.target.closest('[data-close-mobile-filters]');
    if (closeMobileFilters && mobileDrawer) {
      mobileDrawer.classList.remove('is-visible');
      mobileDrawer.setAttribute('aria-hidden', 'true');
      return;
    }

    const mobileBackdrop = event.target.closest('[data-mobile-drawer-backdrop]');
    if (mobileBackdrop && mobileDrawer) {
      mobileDrawer.classList.remove('is-visible');
      mobileDrawer.setAttribute('aria-hidden', 'true');
      return;
    }

    const compareCheck = event.target.closest('[data-compare-check]');
    if (compareCheck) {
      const card = compareCheck.closest('[data-product-card]');
      const input = compareCheck.querySelector('input');
      toggleCompare(card, input ? input.checked : undefined);
      return;
    }

    const desktopCompare = event.target.closest('[data-desktop-compare]');
    if (desktopCompare) {
      handleCompareClick();
      return;
    }

    const compareClose = event.target.closest('[data-desktop-compare-close]');
    if (compareClose) {
      clearCompareSelection();
      return;
    }

    const closeCompare = event.target.closest('[data-close-compare]');
    if (closeCompare && compareModal) {
      compareModal.classList.remove('is-visible');
      compareModal.setAttribute('aria-hidden', 'true');
      return;
    }

    const modalClose = event.target.closest('[data-modal-close]');
    if (modalClose && compareModal) {
      compareModal.classList.remove('is-visible');
      compareModal.setAttribute('aria-hidden', 'true');
      return;
    }

    const pageButton = event.target.closest('[data-page]');
    if (pageButton) {
      currentPage = Number(pageButton.dataset.page || 1);
      applyFilters();
      root.querySelector('#pc-shop-results')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
      return;
    }

    const prev = event.target.closest('[data-page-prev]');
    if (prev) {
      currentPage = Math.max(1, currentPage - 1);
      applyFilters();
      root.querySelector('#pc-shop-results')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
      return;
    }

    const next = event.target.closest('[data-page-next]');
    if (next) {
      currentPage += 1;
      applyFilters();
      root.querySelector('#pc-shop-results')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  });

  root.addEventListener('change', (event) => {
    if (event.target.matches('[data-sort-select]')) {
      currentPage = 1;
      applyFilters();
      return;
    }

    if (event.target.matches('[data-mobile-category-select]')) {
      activeCategory = event.target.value || 'all';
      currentPage = 1;
      updateUrlCategory();
      applyFilters();
      return;
    }

    if (event.target.matches('[data-filter-outdoor-switch]')) {
      state.outdoor = event.target.checked ? 'yes' : 'all';
      currentPage = 1;
      applyFilters();
      return;
    }

    if (event.target.matches('[data-filter-lead]')) {
      if (event.target.checked) {
        state.leadTimes.add(event.target.value);
      } else {
        state.leadTimes.delete(event.target.value);
      }

      currentPage = 1;
      applyFilters();
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      if (compareModal) {
        compareModal.classList.remove('is-visible');
        compareModal.setAttribute('aria-hidden', 'true');
      }

      if (mobileDrawer) {
        mobileDrawer.classList.remove('is-visible');
        mobileDrawer.setAttribute('aria-hidden', 'true');
      }
    }
  });

  updateCategoryButtons();
  applyFilters();
})();